import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/svg/boxes.svg")